"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.hero.title': 'Attivazione Account',
    'activate.hero.description': 'Benvenuto su IntHub! Stiamo attivando il tuo account per farti iniziare.',
    'activate.hero.login_link_text': 'Hai già un account attivo?',
    'activate.hero.login_link': 'Accedi qui',
};
